export default "__VITE_ASSET__DDXq_H9I__"